import React from 'react';

export const CapabilitiesContext = React.createContext();
export const UserContext = React.createContext();
export const SettingsContext = React.createContext();